import Product from './product';

export default Product;
